import { Icon } from '@iconify/react';
import { Box, CircularProgress, Stack, Tooltip, Typography } from '@mui/material';
import useDeleteFloorMutation from 'api/project/mutations/useDeleteFloorMutation';
import { useGetProjectQuery } from 'api/project/queries/useGetProjectQuery';
import { useWorkspaces } from 'contexts/WorkspacesContext';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Floor } from 'utils/floor';

interface FloorCardProps {
  floor: Floor;
}

const FloorCard: React.FC<FloorCardProps> = ({ floor }) => {
  
  const size = 12

  const { projectSlug } = useParams()
  const { activeWorkspace } = useWorkspaces();
  const { data: project } = useGetProjectQuery(projectSlug || "", activeWorkspace.id);

  const { mutate: deleteFloor, isPending: isDeletePending } = useDeleteFloorMutation(project?.id || "");

  const handleDelete = () => {
    if (isDeletePending) return;
    deleteFloor({ id: floor.id });
  };

  return (
    <Stack spacing={1} sx={{ position: 'relative', zIndex: 1 }}>
      <img
        src={floor.image}
        alt={floor.name}
        style={{ width: `${size * 0.8}rem`, height: `${size * 0.8}rem`, borderRadius: '8px', objectFit: 'contain', background: '#fff2' }}
      />
      <Stack alignItems="center" justifyContent="space-between">
        <Typography sx={{
        maxWidth: `${size * 0.8}rem`,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}>{floor.name}</Typography>
        <Box sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 100,
        }}>
        { isDeletePending ? (
          <CircularProgress size={20} color='error' />
        ) : (
          <Icon icon="ph:trash" color='#ff0000' width={"1rem"} height={"1rem"} onClick={handleDelete} />
        ) }
        </Box>
      </Stack>
      { false && !floor.aligned && (
        <Tooltip title="Floor plan not aligned">
        <Icon icon="fluent:warning-32-filled" style={{ position: 'absolute', top: 8, right: 8, zIndex: 100, color: '#FFB800' }} width={20} height={20} />
      </Tooltip>)}
    </Stack>
  );
};

export default FloorCard;